define([
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/heading/AttributeActionMixin"
], function(declare,Action,AttributeActionMixin) {

	return declare([Action, AttributeActionMixin], {
		checkNodeAccess: function(/*Node*/node) {
			// summary: forward call to mixin
			return this._checkAttributeAccess(node, this.heading.m_id, this.heading.m_path);
		},

		_getValue: function(/*Context*/ctx) {
			// summary: return value of attribute in context
			var	node = ctx.getNode();
			var	v = node ? node[this.heading.m_id] : null;
			return (v && ctx.hasContainerKey()) ? v[ctx.keyValue] : v;
		}
	});
});